import React from "react";
import Icon from "./Icon";

/**
 * Карточка игры из фида Рублокса.
 * thumbnail — data-URI base64 JPEG. Клик не ведёт в браузерную игру
 * (играть можно только в приложении) — открывает модалку «скачай приложение».
 */
export default function GameCard({ game, onClick }) {
  const {
    title,
    author_username,
    thumbnail,
    play_count = 0,
    likes_count = 0,
    genre,
  } = game;

  return (
    <button
      type="button"
      className="rb-gamecard"
      onClick={() => onClick(game)}
      title={`${title} — скачайте приложение, чтобы играть`}
    >
      <div className="rb-gamecard__thumb">
        {thumbnail ? (
          <img src={thumbnail} alt={title} loading="lazy" />
        ) : (
          <div className="rb-gamecard__thumb-empty">Рублокс</div>
        )}
        {genre && <span className="rb-gamecard__genre">{genreLabel(genre)}</span>}
      </div>
      <div className="rb-gamecard__body">
        <div className="rb-gamecard__title">{title}</div>
        <div className="rb-gamecard__author">@{author_username}</div>
        <div className="rb-gamecard__meta">
          <span title="Запусков">
            <Icon name="play" size={13} />
            {formatNum(play_count)}
          </span>
          <span title="Лайков">
            <Icon name="heart" size={13} />
            {formatNum(likes_count)}
          </span>
        </div>
      </div>
    </button>
  );
}

function formatNum(n) {
  if (n >= 1000) return (n / 1000).toFixed(1).replace(".", ",") + "K";
  return String(n);
}

/** Машинный жанр → русская подпись. */
function genreLabel(genre) {
  const map = {
    action: "Экшен",
    adventure: "Приключения",
    platformer: "Платформер",
    shooter: "Шутер",
    racing: "Гонки",
    puzzle: "Головоломка",
    horror: "Хоррор",
    rpg: "РПГ",
    simulator: "Симулятор",
    obby: "Паркур",
    tycoon: "Тайкун",
    other: "Игра",
  };
  return map[genre] || "Игра";
}
